module.exports = __webpack_public_path__ + "static/022.thumb-a8f153134b42f94685ff2b4385d73b0b.jpg";